import {css} from 'lit';

// language=CSS
export const headers =
    css`
        h1 {
            font-size: 1.75rem;
            line-height: 2.25rem;
        }

        h3 {
            border-bottom: 1px solid rgb(var(--sp-greydark));
            font-family: 'EkMukta-Light';
            font-weight: normal;
            line-height: 20px;
            font-size: 16px;
            margin: 10px 0;
        }

        h4 {
            font-family: 'EkMukta-SemiBold';
            text-transform: uppercase;
            font-weight: normal;
            line-height: 18px;
            font-size: 14px;
            margin: 0;
        }
    `;
